module.exports = __webpack_public_path__ + "teqbahn-assets/media/20.211dc622.png";